jQuery(document).ready(function () {
    'use strict';

    (function (jQuery) {

        // Ersten Punkt auf geöffnet setzen
        var $accordion = jQuery('.tab-trx-accordion'),
            $firstHeadline = $accordion.find('tr:first-child th'),
            $firstContent = $firstHeadline.next('td');

        TweenMax.to([$firstHeadline, $firstContent], 0.4, {
            className: '+=open',
            ease: Power2.easeInOut
        });

        // Accordion Funktionalität
        $accordion.find('th').click(function () {
            var $item = jQuery(this),
                $next = $item.next('td');

            // Wenn nicht geöffnetes Element geklickt wird
            if (!$next.hasClass('open')) {

                var $aktivItemTh = $item.closest('.tab-trx-accordion').find('th.open');
                var $aktivItemTd = $item.closest('.tab-trx-accordion').find('td.open');

                // altes Element ausblenden
                TweenMax.to($aktivItemTh, 0.4, {
                    className: '-=open',
                    ease: Power2.easeInOut
                });

                // altes Element ausblenden
                TweenMax.to($aktivItemTd, 0.4, {
                    height: 0,
                    margin: 0,
                    padding: '0 15px',
                    ease: Power2.easeInOut,
                    onComplete: function () {
                        $aktivItemTd.removeClass('open').removeAttr('style');
                    }
                });

                // Neues Element einblenden
                TweenMax.to([$item, $next], 0.4, {
                    className: '+=open',
                    ease: Power2.easeInOut
                });


            }
        })

    }(jQuery));

});